import { OnInit, Component, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CategoryService } from '../services/category.service';
import { catchError } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { AlertService } from '../services/alert.service';
import { StorageService } from '../services/storage.service';
import jwt_decode from "jwt-decode";
import { Router } from "@angular/router";
import { of } from 'rxjs';
import { SpinnerService } from './../services/spinner.service';
import { MsalService } from '@azure/msal-angular';
import { UploadService } from '../services/upload.service';

@Component({

  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {

  items: any;
  @ViewChild('Category') elCategory: ElementRef;
  private route: ActivatedRoute;
  id:number;
  AddShowHide:boolean = true;
  EditShowHide:boolean = true;
  CreateShowHide:boolean = false;
  UpdateShowHide:boolean = false;
  CancelShowHide = false;
  reverse: boolean = false;
  public username;
  baseUrl = environment.baseUrl;
  filename: any;
  isShown:boolean = true;
  imagesource: any;
  productcategoryimagename: any;

  frmCategory = new FormGroup({
    ProductCategory: new FormControl('', [Validators.required, Validators.minLength(1)]),
    ProductCategoryTitle : new FormControl('', [Validators.required, Validators.minLength(1)]),
    ProductCategoryDescription  : new FormControl('', [Validators.required, Validators.minLength(1)]),
    ProductCategoryImageName  : new FormControl(''),
    CreatedBy: new FormControl('' ),
    CreationDate: new FormControl('' ),
    CategoryImage  : new FormControl('', [Validators.required]),
    OrderBy : new FormControl('', [Validators.required, Validators.minLength(1)]),

  });

  config = {
    id: 'Category',
    itemsPerPage: environment.pagination.pagesize,
    currentPage: 0,
    totalItems: 0,
  };

  param = environment.pagination;
  // {
  //   SortColumnName :"Modifiedby",
  //   SortOrder :"DESC",
  //   PageSelected:0,
  //   PageSize:2
  // };

  constructor(private renderer: Renderer2, private _categoryservice: CategoryService, private _alertService: AlertService,
    private router: Router,
    public storage: StorageService,
    private spinner: SpinnerService,private authService: MsalService,
    private _uploadservice: UploadService,) {
      // const tokenitems = { ...localStorage };
      // if(tokenitems.TokenInfo != undefined) {
      //     var clienttoken = jwt_decode(JSON.parse(tokenitems.TokenInfo).access_token);
      //     var isAdmin;
      //     var groups;
      //     //console.log('clienttoken');
      //     //console.log(clienttoken);
      //     this.username = clienttoken["unique_name"];
      //     groups = clienttoken["groups"].split(',');

      //     isAdmin = groups.indexOf("GPI-Aces-Admins",0) != -1;
      //     if(!isAdmin){
      //         this.router.navigate(['/accessdenied']);
      //     }
      // }

  }
  ngOnInit() {
    this.spinner.showSpinner();
    //console.log(this.param);
    
 const activeAccount = this.authService.instance.getActiveAccount();
 if (activeAccount) {
   this.username = activeAccount.username;
 }
    this.GetCategories();
    this.spinner.hideSpinner();
  }
  SortOder(sortBy){
    if (this.param.SortOrder === "ASC") {
      this.reverse = !this.reverse;
      this.param.SortOrder = "DESC"
    } else{
      this.param.SortOrder = "ASC"
    }
    this.param.SortColumnName = sortBy;
    this.GetCategories();
  }

  Cancel(){
    this.spinner.showSpinner();
    this.id = 0;
    this.frmCategory.setValue({   ProductCategory:"",
                                  ProductCategoryDescription:"",
                                  ProductCategoryTitle:"",
                                  ProductCategoryImageName:"",
                                  CreatedBy: "",
                                  CreationDate: "",
                                  CategoryImage:"",
                                  OrderBy:""

                              });
    this.AddShowHide = true;
    this.EditShowHide = true;
    this.CreateShowHide = false;
    this.UpdateShowHide =false;
    this.CancelShowHide = false;
    this.spinner.hideSpinner();
  }

  GetCategories() {
    this._categoryservice.getProductCategoryList(this.param).subscribe((data: any) => {
      //console.log('data');
      //console.log(data);
      var stringified = JSON.stringify(data);
      this.items = JSON.parse(stringified).PagedDataModel;
      this.config.totalItems = JSON.parse(stringified).page.TotalCount;

   });
  }

  pageChanged(event){
    this.config.currentPage = event;
    this.param.PageSelected = event;
    this.GetCategories();
  }
  EditCategory(item){
    this.spinner.showSpinner();
    //console.log(item);
    this.id = item.Id;
    this.productcategoryimagename = item.ProductCategoryImageName;
    this.frmCategory.setValue({
      ProductCategory:item.ProductCategory1,
      ProductCategoryDescription:item.ProductCategoryDescription,
      ProductCategoryTitle:item.ProductCategoryTitle,
      ProductCategoryImageName: item.ProductCategoryImageName,
      CreatedBy: item.CreatedBy,
      CreationDate: item.CreationDate,
      CategoryImage: item.ProductCategoryImageName,
      OrderBy: item.OrderBy

    });
    //console.log(this.frmCategory);

    this.EditShowHide = false;
    this.AddShowHide = false;
    this.CreateShowHide = false;
    this.UpdateShowHide =true;
    this.CancelShowHide = true;

    //console.log(this.EditShowHide);
    //console.log(this.AddShowHide);
    //console.log(this.UpdateShowHide);
    //console.log(this.frmCategory);

    this.spinner.hideSpinner();
  }
  AddCategory(){
    this.spinner.showSpinner();
    this.id = 0;
    this.AddShowHide = false;
    this.EditShowHide = false;
    this.CreateShowHide = true;
    this.UpdateShowHide =false;
    this.CancelShowHide = true;
    this.spinner.hideSpinner();
  }
  Validation(frmC:FormGroup){
    let invalidfield : String = '';

  if (frmC.invalid) {
      Object.keys(frmC.controls).forEach((key) => {
          if(frmC.get(key).invalid == true){
              // Add validation
              // if(invalidfield == ''){
              //     invalidfield = "Please enter " +  key.charAt(0).toUpperCase() + key.substr(1).toLowerCase()+ "<br/>";
              // } else {
              //     invalidfield += "Please enter " + key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() + "<br/> ";
              // }
          }
      });
      this._alertService.showError(invalidfield);
    }
  }
  CreateCategory(files) {
    this.spinner.showSpinner();
    if (this.frmCategory.invalid) {
      this.Validation(this.frmCategory);
      this.spinner.hideSpinner();
      return;
    }

    if(files[0] != null){
      this.save(files);
    }

    let CategoryModel = {
      productCategory1: this.frmCategory.get('ProductCategory').value,
      productCategoryDescription: this.frmCategory.get('ProductCategoryDescription').value,
      productCategoryTitle: this.frmCategory.get('ProductCategoryTitle').value,
      CreatedBy: this.username,
      CreationDate: new Date(),
      LastModifiedBy: this.username,
      LastModificationDate: new Date(),
      ProductCategoryImageName: this.frmCategory.get('ProductCategoryImageName').value,
      OrderBy: this.frmCategory.get('OrderBy').value

    }

    let retvalue = this._categoryservice.postCategory(CategoryModel);
    retvalue.pipe(
      catchError(err => {
        this._alertService.showError("Error while creating record");
        return of(null);
      })).subscribe((value: any) => {
        this.param.SortOrder = "DESC";
      this.GetCategories();
      this.Cancel();
      this._alertService.showSuccess("Record created successfully");
      })

      this.spinner.hideSpinner();
    }

    UpdateCategory(files) {
      this.spinner.showSpinner();
      if (this.frmCategory.invalid) {
        this.Validation(this.frmCategory);
        this.spinner.hideSpinner();      
        return;
      }

      if(files[0] != null){
        this.save(files);
      }
      
      let CategoryModel = {
        id: this.id,
        productCategory1: this.frmCategory.get('ProductCategory').value,
        productCategoryDescription: this.frmCategory.get('ProductCategoryDescription').value,
        productCategoryTitle: this.frmCategory.get('ProductCategoryTitle').value,
        LastModifiedBy: this.username,
        LastModificationDate: new Date(),
        CreatedBy: this.frmCategory.get('CreatedBy').value,
        CreationDate: this.frmCategory.get('CreationDate').value,
        ProductCategoryImageName: this.frmCategory.get('ProductCategoryImageName').value,
        OrderBy: this.frmCategory.get('OrderBy').value

      }
      //console.log(CategoryModel);
      let retvalue = this._categoryservice.putCategory(CategoryModel);

      retvalue.pipe(
        catchError(err => {
          alert("Error while creating record!!!");
          return of(null);
        })).subscribe((value: any) => {
          this.param.SortOrder = "DESC";
          this.GetCategories();
          this.Cancel();
          setTimeout("",1000);
          this._alertService.showSuccess("Record updated successfully");
        })

        this.spinner.hideSpinner();
  }

  DeleteCategory(categoryId: number) {
    if (confirm('Are you sure to delete this record ?')) {
      this._categoryservice.deleteCategory(categoryId).subscribe(
        (data: any) => {
          this._alertService.showSuccess("Deleted successfully");
        },
        err => {
          if (err.status == 400)
            this._alertService.showError("No data exists");
          else
            this._alertService.showError("Bad request");
        }
      );
      this.GetCategories();
    }      
  }

  setFilename(files) {
    if (files[0]) {
      this.filename = files[0].name;
      this.isShown = false;
    }
  }
  
  save(files) {
    var start = Date.now().toString();
    var timestampSuffix = start.substr(start.length - 4);
    
    if(this.filename===undefined)
      return;
    const formdata = new FormData();
    var filename ='';
    
    
    filename = this.frmCategory.value.ProductCategory + timestampSuffix+  '.jpg';
    if (files[0]) {
      //console.log(files[0].name);
    
      formdata.append(filename, files[0]);
      //console.log("append" )
    }
    //console.log(filename);
    this.frmCategory.patchValue({ProductCategoryImageName: filename});
    //console.log(formdata);
    //console.log(this.frmProduct.value.ProductName);
  
    this._uploadservice
      .upload(formdata)
      .subscribe(({ path }) => (this.imagesource = path));
    formdata.delete(filename);    
    } 

}
